import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";

/**
 * Delivery Estimate Message
 */
import React, { forwardRef } from "react";
import { Alert, Box, Heading, IconDeliveryExpress, IconDeliveryTruck, Text } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var DeliveryEstimateMessage = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = "deliveryEstimate" in props ? props.deliveryEstimate.label : props.label;
  var description = "deliveryEstimate" in props ? props.deliveryEstimate.labelType === "Estimated" ? props.deliveryEstimate.labelDescription : "" : props.description;
  var wrapperProps = props.wrapperProps,
      containerProps = props.containerProps,
      _props$deliveryType = props.deliveryType,
      deliveryType = _props$deliveryType === void 0 ? "STANDARD" : _props$deliveryType;

  var renderIcon = function renderIcon() {
    var commonIconProps = {
      height: 24,
      width: 24,
      color: "secondary"
    };

    switch (deliveryType) {
      case "EXPRESS":
        return ___EmotionJSX(IconDeliveryExpress, _extends({
          "data-testid": "icon-delivery-express"
        }, commonIconProps));

      default:
        return ___EmotionJSX(IconDeliveryTruck, _extends({
          "data-testid": "icon-delivery-standard"
        }, commonIconProps));
    }
  };

  return ___EmotionJSX(Box, _extends({
    ref: ref,
    borderRadius: 4,
    overflow: "hidden"
  }, containerProps), ___EmotionJSX(Alert, {
    type: "inline",
    icon: renderIcon(),
    alignIcon: "flex-start",
    variant: "info",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    wrapperProps: wrapperProps
  }, ___EmotionJSX(Heading.h5, {
    m: 0
  }, label), description && ___EmotionJSX(Text, {
    fontSize: "xs",
    m: 0
  }, description)));
});
DeliveryEstimateMessage.displayName = "DeliveryEstimateMessage";